export const BULK_ACTIONS_TOOLBAR_TESTID = 'software-bulk-actions-toolbar.wrapper';

export const BULK_ACTIONS_BAR_HEIGHT = 32;

export const ALIGN_TO_BACKLOG_CHECKBOXES_PADDING = 17;
